// Wordmark — renders "CookChow" with a subtle terracotta dot on the
// second `o`. Same family as Phase 1's plain text with a slight weight
// bump. Intentionally distinct from lowercase `cookpit` (cookpit is the
// data format; CookChow is the consumer app).
//
// See README §6.1, §7.1.

import { theme } from '../theme';

export type WordmarkSize = 'sm' | 'md' | 'lg';

export interface WordmarkProps {
  size?: WordmarkSize;
  /** Render as <h1> (page heading) or inline <span> (header chrome). */
  as?: 'h1' | 'span';
}

const sizeToPx: Record<WordmarkSize, string> = {
  sm: '1.5rem',
  md: '2.5rem',
  lg: 'clamp(2.5rem, 8vw, 5rem)',
};

export function Wordmark({ size = 'lg', as = 'h1' }: WordmarkProps) {
  const Tag = as;
  const style: React.CSSProperties = {
    margin: 0,
    fontSize: sizeToPx[size],
    fontWeight: 650,
    letterSpacing: '0.02em',
    color: theme.text.primary,
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  };
  // The second `o` is the 6th character ("CookCh[o]w"): C-o-o-k-C-h-o-w.
  // We split the word so the second `o` carries the terracotta dot.
  return (
    <Tag aria-label="CookChow" style={style}>
      CookCh
      <span style={{ position: 'relative', display: 'inline-block' }}>
        o
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '0.05em',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '0.18em',
            height: '0.18em',
            borderRadius: '50%',
            background: theme.accent.action,
          }}
        />
      </span>
      w
    </Tag>
  );
}

export default Wordmark;
